__turbopack_context__.v({
  "card-skeleton": "_8OdXcG_card-skeleton",
});
